interface PaginationProps {
  page: number;
  pages: number;
  total: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
}

export function Pagination({ page, pages, total, limit, onPageChange, onLimitChange }: PaginationProps) {
  const pageNums: (number | '...')[] = [];
  if (pages <= 7) {
    for (let i = 1; i <= pages; i++) pageNums.push(i);
  } else {
    pageNums.push(1);
    if (page > 3) pageNums.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(pages - 1, page + 1); i++) {
      pageNums.push(i);
    }
    if (page < pages - 2) pageNums.push('...');
    pageNums.push(pages);
  }

  return (
    <div class="pagination">
      <div class="pagination-info">
        Page {page} of {pages} · {total.toLocaleString()} results
      </div>
      <div class="pagination-controls">
        <button
          class={`pagination-btn${page <= 1 ? ' disabled' : ''}`}
          onClick={() => page > 1 && onPageChange(page - 1)}
        >‹</button>
        {pageNums.map((p, i) =>
          p === '...' ? (
            <button key={`dots-${i}`} class="pagination-btn" style={{ pointerEvents: 'none', border: 'none' }}>…</button>
          ) : (
            <button
              key={p}
              class={`pagination-btn${p === page ? ' active' : ''}`}
              onClick={() => onPageChange(p)}
            >{p}</button>
          )
        )}
        <button
          class={`pagination-btn${page >= pages ? ' disabled' : ''}`}
          onClick={() => page < pages && onPageChange(page + 1)}
        >›</button>
      </div>
      <div class="per-page">
        <label>Per page:</label>
        <select
          value={limit}
          onChange={(e) => onLimitChange(Number((e.target as HTMLSelectElement).value))}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
}
